import { useEffect, useState } from 'react'
import { 
    VALIDATION_ERROR, 
    VALIDATION_TYPE, 
    ERROR_STRING} from '../../app/errors'
import { ValidateString } from '../../app/utils'
import { ErrorWithString, Paragraph } from "../RegularComponents"

const BranchDetailsForm = (props) => {
    const id = props.id + "-branch-details"
    const {managerHelperText} = props;

    const [branchNameText, setBranchNameText] = useState(props.branchName)

    const [branchAddressText, setBranchAddressText] = useState(props.branchAddress)
    const [branchCityText, setBranchCityText] = useState(props.branchCity)
    const [branchPostalCodeText, setBranchPostalCodeText] = useState(props.branchPostalCode)
    const [branchManagerNameText, setBranchManagerNameText] = useState(props.branchManagerName)
    const [phoneNumberText, setPhoneNumberText] = useState(props.phoneNumber)
    const [branchManagerEmailText, setBranchManagerEmailText] = useState(props.branchManagerEmail)

    const [showValidationError, setShowValidationError] = useState(props.showValidationError)
    const [branchNameError, setBranchNameError] = useState(VALIDATION_ERROR.NO_ERROR)
    const [addressError, setAddressError] = useState(VALIDATION_ERROR.NO_ERROR)
    const [cityError, setCityError] = useState(VALIDATION_ERROR.NO_ERROR)
    const [postalCodeError, setPostalCodeError] = useState(VALIDATION_ERROR.NO_ERROR)
    const [managerNameError,setManagerNameError] = useState(VALIDATION_ERROR.NO_ERROR)
    const [phoneNumberError,setPhoneNumberError] = useState(VALIDATION_ERROR.NO_ERROR)
    const [emailError,setEmailError] = useState(VALIDATION_ERROR.NO_ERROR)

    // This function is needed to update the contents of each input text with the latest
    // prop values. Use case comes in "Remove" kind of scenarios.
    useEffect(() => {

        const validateBranchName = () => {
            const ret = ValidateString(branchNameText,VALIDATION_TYPE.STRING_NON_EMPTY)
            setBranchNameError(ret)
            return (ret === VALIDATION_ERROR.NO_ERROR)
        }

        const validateBranchAddress = () => { 
            const ret = ValidateString(branchAddressText,VALIDATION_TYPE.STRING_NON_EMPTY)
            setAddressError(ret)
            return (ret === VALIDATION_ERROR.NO_ERROR)
        }

        const validateBranchCity = () => { 
            const ret = ValidateString(branchCityText,VALIDATION_TYPE.STRING_NON_EMPTY)
            setCityError(ret)
            return (ret === VALIDATION_ERROR.NO_ERROR)
        }

        const validateBranchPostalCode = () => { 
            const ret = ValidateString(branchPostalCodeText,VALIDATION_TYPE.CANADA_POSTAL_CODE)
            setPostalCodeError(ret)
            return (ret === VALIDATION_ERROR.NO_ERROR)
        }

        const validateManagerName = () => { 
            const ret = ValidateString(branchManagerNameText, VALIDATION_TYPE.NAME)
            setManagerNameError(ret)
            return (ret === VALIDATION_ERROR.NO_ERROR)
        }

        const validateEmail = () => { 
            const ret = ValidateString(branchManagerEmailText,VALIDATION_TYPE.EMAIL)
            setEmailError(ret)
            return (ret === VALIDATION_ERROR.NO_ERROR)
        }

        const validatePhoneNumber = () => {
            const ret = ValidateString(phoneNumberText,VALIDATION_TYPE.PHONE_NUMBER)
            setPhoneNumberError(ret)
            return (ret === VALIDATION_ERROR.NO_ERROR)
        }

        setBranchNameText(props.branchName)
        setBranchAddressText(props.branchAddress)
        setBranchCityText(props.branchCity)
        setBranchPostalCodeText(props.branchPostalCode)
        setBranchManagerNameText(props.branchManagerName)
        setPhoneNumberText(props.phoneNumber)
        setBranchManagerEmailText(props.branchManagerEmail)
        setShowValidationError(props.showValidationError)

        if(props.showValidationError) {
            validateBranchAddress()
            validateBranchCity()
            validateBranchPostalCode()
            validateBranchName()
            validateManagerName()
            validatePhoneNumber()
            validateEmail()
        }
        
    }, [
        props.branchName, 
        props.branchAddress,
        props.branchCity,
        props.branchPostalCode, 
        props.branchManagerName, 
        props.phoneNumber, 
        props.branchManagerEmail,
        props.showValidationError,
        branchNameText,
        branchAddressText,
        branchCityText,
        branchPostalCodeText,
        branchManagerNameText,
        branchManagerEmailText,
        phoneNumberText
    ])

    const isBranchNameValid = () => { 
        if(showValidationError) { 
            return (branchNameError === VALIDATION_ERROR.NO_ERROR)
        }

        return true
    }

    const isBranchAddressValid = () => { 
        if(showValidationError) { 
            return (addressError === VALIDATION_ERROR.NO_ERROR)
        }

        return true
    }

    const isBranchCityValid = () => { 
        if(showValidationError) { 
            return (cityError === VALIDATION_ERROR.NO_ERROR)
        }

        return true
    }

    const isBranchPostalCodeValid = () => { 
        if(showValidationError) { 
            return (postalCodeError === VALIDATION_ERROR.NO_ERROR)
        }

        return true
    }

    const isManagerNameValid = () => { 
        if(showValidationError) { 
            return (managerNameError === VALIDATION_ERROR.NO_ERROR)
        }

        return true
    }

    const isManagerEmailValid = () => { 
        if(showValidationError) { 
            return (emailError === VALIDATION_ERROR.NO_ERROR)
        }

        return true
    }

    const isManagerPhoneNumberValid = () => { 
        if(showValidationError) { 
            return (phoneNumberError === VALIDATION_ERROR.NO_ERROR)
        }

        return true
    }

    const postalCodeErrorString = () => {
        if(postalCodeError === VALIDATION_ERROR.CANADA_POSTAL_CODE_INVALID) { 
            return ERROR_STRING.ADDITIONAL_BRANCH_ADDRESS_POSTAL_CODE_INVALID
        } else if(postalCodeError === VALIDATION_ERROR.EMPTY) { 
            return ERROR_STRING.ADDITIONAL_BRANCH_ADDRESS_POSTAL_CODE_EMPTY
        } else if(postalCodeError !== VALIDATION_ERROR.NO_ERROR) { 
            return ERROR_STRING.ADDITIONAL_BRANCH_ADDRESS_POSTAL_CODE_EMPTY
        }

        return ""
    }

    const managerPhoneNumberErrorString = () => { 
        switch(phoneNumberError) { 
            case VALIDATION_ERROR.PHONE_NUMBER_INVALID : 
            case VALIDATION_ERROR.PHONE_NUMBER_NOT_10_DIGIT : 
                return ERROR_STRING.ADDITIONAL_BRANCH_MANAGER_PHONE_NOT_10
            case VALIDATION_ERROR.EMPTY : 
            default :
                return ERROR_STRING.ADDITIONAL_BRANCH_MANAGER_PHONE_EMPTY
        }
    }

    const emailErrorString = () => { 
        switch(emailError) { 
            case VALIDATION_ERROR.EMAIL_INVALID : 
                return ERROR_STRING.ADDITIONAL_BRANCH_MANAGER_EMAIL_INVALID
            case VALIDATION_ERROR.EMPTY : 
            default : 
                return ERROR_STRING.ADDITIONAL_BRANCH_MANGER_EMAIL_EMPTY
        }
    }

    return (
        <fieldset className={"ns-fieldset"} id={id + "-form"}>
            <div className={"ns-fieldset" + (!isBranchNameValid() ? " ns-fieldset-message-error" : "")}>
                {/* Branch Name */}
                <label
                    className="ns-label" 
                    id={id + "-branch-name-label"}
                    htmlFor={id + "-branch-name-text"}>
                        Branch name
                </label>
                {!isBranchNameValid() && 
                <span id={id + "-branch-name-error"} className="ns-error-message field-validation-error">
                    {ErrorWithString(ERROR_STRING.ADDITIONAL_BRANCH_BRANCH_NAME_EMPTY)}
                </span>
                }
                <input
                    type="text"
                    className={"fw-20 " + (isBranchNameValid() ? " ns-input" : " ns-input--error") }
                    id={id + "-branch-name-text"}
                    name={id + "-branch-name-text"}
                    value={branchNameText}
                    onChange={(e) => {
                        setBranchNameText(e.target.value)
                        props.onDetailsChange({
                            id: props.id,
                            updatedDetails : {
                                branchName : e.target.value
                            }
                        })
                    }}
                />
            </div>
            {/* Branch street */}
            <div className={"ns-fieldset" + (!isBranchAddressValid() ? " ns-fieldset-message-error" : "")}>
                <label 
                    id={id + "-branch-civic-address-label"}
                    className="ns-label"
                    autoComplete="street-address"
                    htmlFor={id + "-branch-civic-address-text"}>
                        Branch street address
                </label>
                {!isBranchAddressValid() && 
                <span id={id + "-branch-civic-address-text-error"} className="ns-error-message field-validation-error">
                    {ErrorWithString(ERROR_STRING.ADDITIONAL_BRANCH_ADDRESS_EMPTY)}
                </span>}
                <input
                    type="text"
                    className={"fw-25" + (isBranchAddressValid() ? " ns-input" : " ns-input--error")}
                    id={id + "-branch-civic-address-text"}
                    name={id + "-branch-civic-address-text"}
                    value={branchAddressText}
                    onChange={(e) => {
                        setBranchAddressText(e.target.value)
                        props.onDetailsChange({
                            id: props.id,
                            updatedDetails : {
                                branchAddress : e.target.value
                            }
                        })
                    }}
                />
            </div>
            {/* BRANCH CITY/TOWN */}
            <div className={"ns-fieldset" + (!isBranchCityValid() ? " ns-fieldset-message-error" : "")}>
                <label 
                    id={id + "-branch-civic-address-city-label"}
                    className="ns-label"
                    autoComplete="city"
                    htmlFor={id + "-branch-civic-address-city-text"}>
                        Branch city/town
                </label>
                {!isBranchCityValid() && 
                <span id={id + "-branch-civic-address-city-text-error"} className="ns-error-message field-validation-error">
                    {ErrorWithString(ERROR_STRING.ADDITIONAL_BRANCH_ADDRESS_CITY_EMPTY)}
                </span>}
                <input
                    type="text"
                    className={"fw-25" + (isBranchCityValid() ? " ns-input" : " ns-input--error")}
                    id={id + "-branch-civic-address-city-text"}
                    name={id + "-branch-civic-address-city-text"}
                    autoComplete="address-level2"
                    value={branchCityText}
                    onChange={(e) => {
                        setBranchCityText(e.target.value)
                        props.onDetailsChange({
                            id: props.id,
                            updatedDetails : {
                                branchCity : e.target.value
                            }
                        })
                    }}
                />
            </div>
            {/* BRANCH POSTAL CODE */}
            <div className={"ns-fieldset" + (!isBranchPostalCodeValid() ? " ns-fieldset-message-error" : "")}>
                <label 
                    id={id + "-branch-civic-address-postal-code-label"}
                    className="ns-label"
                    autoComplete="postal-code"
                    htmlFor={id + "-branch-civic-address-postal-code-text"}>
                        Branch postal code
                </label>
                {!isBranchPostalCodeValid() && 
                <span id={id + "-branch-civic-address-postal-code-text-error"} className="ns-error-message field-validation-error">
                    {ErrorWithString(postalCodeErrorString())}
                </span>}
                <input
                    type="text"
                    className={"fw-25" + (isBranchPostalCodeValid() ? " ns-input" : " ns-input--error")}
                    id={id + "-branch-civic-address-postal-code-text"}
                    name={id + "-branch-civic-address-postal-code-text"}
                    value={branchPostalCodeText}
                    onChange={(e) => {
                        setBranchPostalCodeText(e.target.value)
                        props.onDetailsChange({
                            id: props.id,
                            updatedDetails : {
                                branchPostalCode : e.target.value
                            }
                        })
                    }}
                />
            </div>
            {/* Branch Manager */}
            {managerHelperText && <Paragraph 
                id="new-branch-manager-helper-text"
                text={managerHelperText} />}
            <div className={"ns-fieldset" + (!isManagerNameValid() ? " ns-fieldset-message-error" : "")}>
                <label 
                    id={id + "-branch-manager-name-label"}
                    className="ns-label"
                    htmlFor={id + "-branch-manager-name-text"}>
                        Responsible agent
                </label>
                {!isManagerNameValid() && 
                <span id={id + "-branch-manager-name-text-error"} className="ns-error-message field-validation-error">
                    {ErrorWithString(ERROR_STRING.ADDITIONAL_BRANCH_MANAGER_NAME_EMPTY)}
                </span>}
                <input
                    type="text"
                    className={"fw-20" + (isManagerNameValid() ? " ns-input" : " ns-input--error")}
                    id={id + "-branch-manager-name-text"}
                    value={branchManagerNameText}
                    name={id + "-branch-manager-name-text"}
                    onChange={(e) => {
                        setBranchManagerNameText(e.target.value)
                        props.onDetailsChange({
                            id: props.id,
                            updatedDetails : {
                                branchManagerName : e.target.value
                            }
                        })
                    }}
                />
                
           </div>
            <div className={"ns-fieldset" + (!isManagerPhoneNumberValid() ? " ns-fieldset-message-error" : "")}>
                {/* Phone Number */}
                <label 
                    id={id + "-branch-phone-number-label"}
                    className="ns-label"
                    autoComplete="tel"
                    htmlFor={id + "-branch-phone-number-text"}>
                        Phone
                </label>
                {!isManagerPhoneNumberValid() && 
                <span id={id + "-branch-phone-number-text-error"} className="ns-error-message field-validation-error">
                    {ErrorWithString(managerPhoneNumberErrorString())}
                </span>}
                <input
                    type="text"
                    id={id + "-branch-phone-number-text"}
                    name={id + "-branch-phone-number-text"}
                    className={"fw-20" + (isManagerPhoneNumberValid() ? " ns-input" : " ns-input--error")}
                    value={phoneNumberText}
                    onChange={(e) => {
                        setPhoneNumberText(e.target.value)
                        props.onDetailsChange({
                            id: props.id,
                            updatedDetails : {
                                phoneNumber : e.target.value
                            }
                        })
                    }}
                />
            </div>
            <div className={"ns-fieldset" + (!isManagerEmailValid() ? " ns-fieldset-message-error" : "")}>
                {/* Email */}
                <label 
                    id={id + "-branch-email-label"}
                    className="ns-label"
                    htmlFor={id + "-branch-email-text"}>
                        Responsible agent email
                </label>
                {!isManagerEmailValid() && 
                <span id={id + "-branch-email-text-error"} className="ns-error-message field-validation-error">
                    {ErrorWithString(emailErrorString())}
                </span>}
                <input
                    type="text"
                    id={id + "-branch-email-text"}
                    name={id + "-branch-email-text"}
                    className={"fw-20" + (isManagerEmailValid() ? " ns-input" : " ns-input--error")}
                    autoComplete="email"
                    value={branchManagerEmailText}
                    onChange={(e) => {
                        setBranchManagerEmailText(e.target.value)
                        props.onDetailsChange({
                            id: props.id,
                            updatedDetails : {
                                branchManagerEmail : e.target.value
                            }
                        })
                    }}
                />
            </div>
        </fieldset>
    )
}

export default BranchDetailsForm
